var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: { card: _vm.isCardStyle } }, [
    _c("div", { class: { "card-header border-0": _vm.isCardStyle } }, [
      _c(
        "div",
        {
          staticClass: "d-flex align-items-center",
          class: _vm.classAlignTools,
        },
        [
          _c("div", {}, [
            _c(
              "div",
              { staticClass: "card-title mb-0", class: _vm.classTitle },
              [_vm._v(_vm._s(_vm.$t(_vm.itemTitle)))]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "small text-medium-emphasis" }, [
              _vm._v(_vm._s(_vm.$t(_vm.itemLabel))),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "btn-toolbar d-none d-md-block",
              attrs: { role: "toolbar", "aria-label": "Toolbar with Buttons" },
            },
            [
              _vm.showFilters
                ? _c(
                    "div",
                    {
                      staticClass: "card-filters btn-group",
                      class: _vm.classTools,
                      attrs: { role: "group", "aria-label": "Filter Buttons" },
                    },
                    _vm._l(_vm.filterButtons, function (btn, idx) {
                      return _c(
                        "button",
                        {
                          key: `btn-filter-${idx}`,
                          class: [
                            "btn btn-outline-main min-w-auto",
                            { active: false },
                          ],
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t(btn.name)) +
                              "\n                    "
                          ),
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showTools
                ? _c(
                    "div",
                    {
                      staticClass: "card-tools btn-group",
                      class: _vm.classTools,
                      attrs: { role: "group", "aria-label": "Tools Buttons" },
                    },
                    _vm._l(_vm.toolsButtons, function (btn, idx) {
                      return _c(
                        "button",
                        {
                          key: `btn-tool-${idx}`,
                          staticClass: "btn btn-link btn-tool",
                          attrs: {
                            type: "button",
                            title: _vm.$t(btn.title ?? btn.name),
                            "aria-label": _vm.$t(btn.title ?? btn.name),
                            "data-dismiss": "modal",
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return btn.fn.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c(
                            "span",
                            [
                              btn.name
                                ? [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.$t(btn.name)) +
                                        "\n                            "
                                    ),
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              btn.icon
                                ? [_c("i", { class: btn.icon })]
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
            ]
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { class: { "card-body": _vm.isCardStyle } }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _vm.hasData
            ? _c(
                "div",
                { staticClass: "chart-wrapper" },
                [
                  _c(_vm.chartComponent, {
                    tag: "component",
                    attrs: {
                      chartOptions: _vm.chartOptions,
                      chartData: _vm.chartData,
                      chartId: _vm.chartId,
                      datasetIdKey: _vm.chartDatasetIdKey,
                      plugins: _vm.chartPlugins,
                      cssClasses: _vm.chartCssClasses,
                      chartStyle: _vm.chartStyle,
                      width: _vm.chartWidth,
                      height: _vm.chartHeight,
                    },
                  }),
                ],
                1
              )
            : _c(
                "div",
                {
                  staticClass: "alert alert-light text-center",
                  attrs: { role: "alert" },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.notDataInfo) +
                      "\n                "
                  ),
                ]
              ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _vm.dataFooter.length
      ? _c("div", { class: { "card-footer": _vm.isCardStyle } }, [
          _c(
            "div",
            { staticClass: "row text-center" },
            _vm._l(_vm.dataFooter, function (fItem, fIdx) {
              return _c(
                "div",
                {
                  key: `footer-element-${fIdx}`,
                  staticClass:
                    "col mb-sm-2 mb-0 d-flex flex-column justify-content-between",
                },
                [
                  _c("div", { staticClass: "text-medium-emphasis" }, [
                    _vm._v(_vm._s(fItem.label)),
                  ]),
                  _vm._v(" "),
                  _c("strong", [
                    _vm._v(
                      _vm._s(fItem.value) +
                        " " +
                        _vm._s(fItem.percent ? `(${fItem.percent}%)` : "")
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "progress progress-thin mt-2",
                      attrs: { precision: "1" },
                    },
                    [
                      _c("div", {
                        class: ["progress-bar", `bg-${fItem.color}`],
                        style: { width: `${fItem.percent}%` },
                        attrs: {
                          role: "progressbar",
                          "aria-valuenow": fItem.percent,
                          "aria-valuemin": "0",
                          "aria-valuemax": "100",
                        },
                      }),
                    ]
                  ),
                ]
              )
            }),
            0
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }